<script>
/**
 * Mixin for picking a display config preset for management indicator charts
 */

import { cloneDeep } from 'lodash';
import mixinMgtPagesOptions from '@/mixins/page-options/mgt-pages.vue';
import { mapLibraryToRadio } from '@/utils/indicator-utils';
import { GET_LIBRARY_INDICATORS } from '@/store/mutation-types';
import { FETCH_LIBRARY_INDICATORS } from '@/store/action-types';

export default {

  mixins: [mixinMgtPagesOptions],

  computed: {
    mgtIdcOptions() {
      return [
        ...this.mgtPagesOptions,
        {
          key: 'mgtIdcOptDefaultConfig',
          value: this.mgtIdcOptDefaultConfig,
          component: 'IndicatorDisplayConfigField',
          options: {
            class: 'mt5em',
          },
        },
        {
          key: 'viewTitle',
          value: '',
          component: 'Div',
          options: {
            class: 'legend mt5em',
          },
          slots: [{
            component: 'span',
            content: `${this.$t('message.VISUAL_MODE')} ${this.$t('message.TWO_DOTS')}`,
          }],
        },
        {
          key: 'viewMode',
          component: 'RadioGroup',
          value: this.mgtIdcOptViewMode,
          options: {
            items: [
              { id: 0, label: this.$t('message.COMPACT') },
              { id: 1, label: this.$t('message.CUMUL') },
            ],
          },
        },
        {
          key: 'mgtIdcOptSelectedLibraryIndicators',
          component: 'EditableLabelRadio',
          value: this.mgtIdcOptSelectedLibraryIndicators,
          options: {
            items: this.mgtIdcOptLibraryIndicators,
            labelKey: 'name',
            legend: this.$t('message.MGT_SELECTED_INDICATORS', { n: this.mgtIdcOptSelectedLibraryIndicators.length }),
            multiple: true,
            noText: true,
          },
        },
        {
          key: 'mgtIdcDisplayGwTitle',
          value: '',
          component: 'Div',
          options: {
            class: 'legend mt5em',
          },
          slots: [{
            component: 'span',
            content: `${this.$t('message.DISPLAY')} ${this.$t('message.TWO_DOTS')}`,
          }],
        },
        {
          key: 'mgtIdcDisplayGw',
          component: 'Checkbox',
          value: this.mgtIdcDisplayGw,
          options: {
            title: this.$t('message.MGT_COMPACT_DISPLAY_GW_INDICATORS'),
          },
        },
      ];
    },
    mgtIdcOptViewMode() {
      if (this.allPageOptions && this.allPageOptions.viewMode !== undefined) {
        return this.allPageOptions.viewMode;
      }
      return 1; // 1 = cumulate viewMode
    },
    /** Boolean: Wether GW indicators should be displayed */
    mgtIdcDisplayGw() {
      if (this.allPageOptions && this.allPageOptions.mgtIdcDisplayGw !== undefined) {
        return !!this.allPageOptions.mgtIdcDisplayGw;
      }
      return false;
    },
    /** Object: Display config of indicators */
    mgtIdcOptDefaultConfig() {
      if (this.allPageOptions && this.allPageOptions.mgtIdcOptDefaultConfig !== undefined) {
        return this.allPageOptions.mgtIdcOptDefaultConfig;
      }
      return 1;
    },
    /** Pickable indicators from the library to be displayed in the cumulated view */
    mgtIdcOptLibraryIndicators() {
      return mapLibraryToRadio(this, cloneDeep(this.$store.state[GET_LIBRARY_INDICATORS.stateKey] || []));
    },
    /** Array: Indicators selected in the library */
    mgtIdcOptSelectedLibraryIndicators() {
      if (this.allPageOptions && this.allPageOptions.mgtIdcOptSelectedLibraryIndicators !== undefined) {
        return this.allPageOptions.mgtIdcOptSelectedLibraryIndicators;
      }
      return [];
    },
  },

  created() {
    if (this.currentTeam && this.currentTeam.id) {
      this.$store.dispatch(FETCH_LIBRARY_INDICATORS);
    }
  },

  methods: {
    mgtIdcOptQueryParams(options) {
      const initialQuery = this.mgtPagesOptQueryParams(options);
      if (!options) {
        return initialQuery;
      }
      let query = initialQuery;
      let amp = initialQuery === '' ? '' : '&';
      if (options.mgtIdcOptDefaultConfig !== undefined) {
        query += `${amp}mgtIdcOptDefaultConfig=${options.mgtIdcOptDefaultConfig}`;
        amp = '&';
      }
      if (options.viewMode !== undefined) {
        query += `${amp}viewMode=${options.viewMode}`;
        amp = '&';
      }
      if (options.mgtIdcDisplayGw !== undefined) {
        query += `${amp}mgtIdcDisplayGw=${options.mgtIdcDisplayGw}`;
        amp = '&';
      }
      if (options.mgtIdcOptSelectedLibraryIndicators !== undefined) {
        query += `${amp}mgtIdcOptLibraryIndicators=${options.mgtIdcOptSelectedLibraryIndicators.join(',')}`;
        amp = '&';
      }
      return query;
    },
  },
};
</script>
